import React, {Component} from 'react';


export default class AxisLines extends Component {

    render() {
        return (
            <div>
                <div className={"axis-line"} style={{marginTop: 0}}>
                    <div className={"axis-text"}>100%</div>
                </div>
                <div className={"axis-line no-line"} style={{marginTop: 20}}>
                    <div className={"axis-text"}>90%</div>
                </div>
                <div className={"axis-line no-line"} style={{marginTop: 40}}>
                    <div className={"axis-text"}>80%</div>
                </div>
                <div className={"axis-line no-line"} style={{marginTop: 60}}>
                    <div className={"axis-text"}>70%</div>
                </div>
                <div className={"axis-line no-line"} style={{marginTop: 80}}>
                    <div className={"axis-text"}>60%</div>
                </div>
                <div className={"axis-line no-line"} style={{marginTop: 100}}>
                    <div className={"axis-text"}>50%</div>
                </div>
                <div className={"axis-line no-line"} style={{marginTop: 120}}>
                    <div className={"axis-text"}>40%</div>
                </div>
                <div className={"axis-line no-line"} style={{marginTop: 140}}>
                    <div className={"axis-text"}>30%</div>
                </div>
                <div className={"axis-line no-line"} style={{marginTop: 160}}>
                    <div className={"axis-text"}>20%</div>
                </div>
                <div className={"axis-line no-line"} style={{marginTop: 180}}>
                    <div className={"axis-text"}>10%</div>
                </div>
                <div className={"axis-line"} style={{top: 201}}>
                    <div className={"axis-text"}>0%</div>
                </div>
            </div>

        );
    }
}





// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/ourPartners/components/axisLines/AxisLines.js